import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"padding":"0.22rem"} }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { Axios } from "../assets/js/ls_com_axios.js";
import { ref, onMounted, nextTick } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'leftTemplate4',
  props: {
  left_tabShow: String,
},
  emits: ['back'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const clickclikc = ref('')
const menuList = ref([]);
const menuList1 = ref([]);
const props = __props;
onMounted(() => {
  nextTick(() => {
    clickclikc.value = props.left_tabShow ? props.left_tabShow : ''
    init()
  })
})
const init = () => {
  Axios('get', '/system/dict/data/type/sys_notice', {}, false, (res) => {
    if (res.data.code == 200) {
      menuList.value = res.data.data
    } else {
      ElMessage({
        message: res.data.msg,
        type: 'error',
      })
    }
  })
  Axios('get', '/system/dict/data/type/sys_sck', {}, false, (res) => {
    if (res.data.code == 200) {
      menuList1.value = res.data.data
    } else {
      ElMessage({
        message: res.data.msg,
        type: 'error',
      })
    }
  })
}
const emit = __emit
//直接跳转
const selectcheck = (type: any) => {
  console.log("dianji ", type);
  clickclikc.value = type.dictValue
  emit('back', clickclikc.value)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "left_title" }, "网站协议", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["left_tab", clickclikc.value == item.dictValue ? 'left_tab_select' : ''
        ]),
          onClick: ($event: any) => (selectcheck(item))
        }, _toDisplayString(item.dictLabel), 11, _hoisted_2))
      }), 256)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "left_title" }, "素材库", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList1.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["left_tab", clickclikc.value == item.dictValue ? 'left_tab_select' : ''
        ]),
          onClick: ($event: any) => (selectcheck(item))
        }, _toDisplayString(item.dictLabel), 11, _hoisted_3))
      }), 256))
    ])
  ]))
}
}

})